import { TypeEnum } from 'libs/shared-models/masters/src/lib/enums/stock-item-category-status.enum';
import { Column,CreateDateColumn,Entity,OneToMany,PrimaryGeneratedColumn,UpdateDateColumn,} from 'typeorm';
import { Item } from '../items/item.entity';

@Entity('stock_item_categories')
export class  StockItemEntity {
  @PrimaryGeneratedColumn('increment', { name: 'id' })
  id: number;


@Column('varchar', {
    nullable: false,
    // length: 30,
    name: 'category',
})
category: string;


@Column({
    type: 'enum',
    enum: TypeEnum,
    nullable: false,
    name: 'type'
})
type: string;
    
    @CreateDateColumn({
        name: 'created_at',
        type: 'datetime',
    })
    createdAt: Date;
    
        @UpdateDateColumn({
            name: "updated_at",
            type:'datetime'
        })
        updatedAt: Date;

        
    @Column('varchar', {
        nullable: true,
        name: 'updated_user',
        length: 50,
    })
    updatedUser: string | null;

    @Column('varchar', {
        nullable: true,
        name: 'created_user',
        length: 50,
    })
    createdUser: string | null;


    @OneToMany(type => Item, venPrcList => venPrcList.categoryInfo)
    itemInfo: Item[];
  


    
}

    
